import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Pre-registrar el SW de Braze al cargar la app para que esté listo antes del login
if (environment.braze?.apiKey && environment.braze?.endpoint && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      const hasBrazeSw = regs.some((r) =>
        r.active?.scriptURL?.includes('braze-sw.js') ||
        r.installing?.scriptURL?.includes('braze-sw.js') ||
        r.waiting?.scriptURL?.includes('braze-sw.js')
      );
      if (!hasBrazeSw) {
        navigator.serviceWorker.register('/braze-sw.js', { scope: '/' }).catch(() => {});
      }
    });
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
